import { Component } from "react"

class ErrorBoundary extends Component {
  state = { hasError: false, error: null }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error("FlowCanvas error:", error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-fallback p-8 text-center">
          <h2 className="text-xl font-bold text-red-600">Unable to load diagram</h2>
          <p className="text-gray-600 mt-2">Please refresh the page or try again later.</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Refresh
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
